/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */
import axios from "axios";
import {
  listParamForUserPerVehiculeURL,
  updateParamForUserPerVehiculeURL,
} from "config/api";
import { encryptStorage } from "components/EncryptedStorage/encryptedStorage";
import { updatePermissionForUserPerVehiculeURL } from "config/api";

export const getListParamForUserPerVehicule = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);

  //console.log("datatosend = ", data)
  return axios
    .post(listParamForUserPerVehiculeURL, data.data, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const getListParamForCurrentUserPerVehicule = async () => {
  const userInfo = await encryptStorage.getItem("userInfo");
  const token = "Bearer " + userInfo.userToken;
  const user = userInfo.userName;
  const userNameToSend = { email: user };

  return axios
    .post(listParamForUserPerVehiculeURL, userNameToSend, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const updateParamForUserPerVehiculeForCust = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);

  return axios
    .post(updateParamForUserPerVehiculeURL, data.param.dataParametre, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const updatePermissionForUserPerVehiculeForCust = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);

  return axios
    .post(updatePermissionForUserPerVehiculeURL, data.param.dataPermission, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const updateParamForCurrentUserPerVehiculeForCust = async (data) => {
  const userInfo = await encryptStorage.getItem("userInfo");
  const token = "Bearer " + userInfo.userToken;
  const user = userInfo.userName;

  const dataToSend = {
    ...data.param,
    email: user,
  };

  return axios
    .post(updateParamForUserPerVehiculeURL, dataToSend, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};
